import {deviceIsMobile} from '../utilities/size-check'

$('.js-mobile-menu').on('click', function(e) {
  e.preventDefault();

  const $mobileMenu = $('.mobile-menu');

  $mobileMenu.toggleClass('is-expanded');
  $('body').toggleClass('has-menu-opened')
})

$('.js-close-inner-menu').on('click', function(e) {
  e.preventDefault();

  $(this).closest('.sub-menu').removeClass('is-expanded')
})

$('.mobile-menu .js-dropdown a').on('click', function(e) {
  e.preventDefault();

  const $this = $(this);
  $this.parent().toggleClass('is-expanded')
  $this.next().slideToggle();
})